import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import { Spin } from 'antd';
import { useParams } from 'react-router';

import { useGetSchoolDataQuery } from '@/api/endpoints/schools';
import { ROUTES } from '@/shared/consts';
import type { ESchoolType } from '@/shared/types';

interface IProps {
  permittedTypes: ESchoolType[];
  urlToRedirect?: string;
}

export const SchoolTypeGuard = ({
  permittedTypes,
  urlToRedirect = `/${ROUTES.PUBLIC_PAGES}/${ROUTES.SCHOOLS}`,
  children,
}: PropsWithChildren<IProps>) => {
  const { id: schoolId } = useParams();

  const { data } = useGetSchoolDataQuery({ id: Number(schoolId) });

  const [isPermittedSchoolType, setIsPermittedSchoolType] = useState(false);

  useEffect(() => {
    if (!data) {
      return;
    }

    if (permittedTypes.includes(data.school_type)) {
      setIsPermittedSchoolType(true);
    } else {
      window.location.replace(urlToRedirect);
    }
  }, [data]);

  if (isPermittedSchoolType) {
    return children;
  }

  return (
    <Spin
      fullscreen
      size="large"
    />
  );
};
